import React from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import { Button, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import LoaderButton from "../../../../shared-components/button/loader-button";
import FormLoader from "../../../../shared-components/FormLoader/FormLoader";
import { formatMessage } from "../../../../translations/format-message";



interface IProps {
  id: number; // ID of the shift selector
  isLoading: boolean; // Loading state
  staffId: number; // Staff ID
  shiftList: any[]; // List of available shifts
  submitHandler: (data: any) => void; // Submit handler function
  onModalClosed: () => void; // Function to handle modal close
  initialValues: any; // Initial form values
  shiftScheduleList: any[]; // List of assigned shift schedules
}

const ShiftSelector = (props: IProps) => {

  // Validation schema for shift selection
const ShiftSelectorSchema = Yup.object().shape({
  selectedShift: Yup.string()
    .notOneOf(["-1"], (formatMessage("please_select_shift")))
    .required(formatMessage("shift_selection_is_required")),
});

  // Handle form submission
  const handleSubmit = (values: any, { setSubmitting }: any) => {
    props.submitHandler(values);
    setSubmitting(false);
  };

  return (
    <React.Fragment>
      {/* Show loader if loading */}
      {props.isLoading && <FormLoader loading={props.isLoading} />}

      {/* Render form if no shift is assigned */}
      {props.shiftScheduleList?.length == 0 ? (
        <div className="">
          
          <Formik
            initialValues={props.initialValues}
            validationSchema={ShiftSelectorSchema}
            onSubmit={handleSubmit}
          >
            {({ values, errors, touched, isSubmitting }) => (
              <Form>
                <FieldArray name="shifts">
                  {() => (
                    <div className="">
                      {/* Render shift options */}
                      {props.shiftList?.map((shift) => (
                        <div key={shift.id} className="flex items-center my-3">
                            <Field
                              type="radio"
                              name="selectedShift"
                              id={JSON.stringify(shift.id)}
                              value={JSON.stringify(shift.id)}
                              className="form-check-input"
                            />
                            <label
                              className="form-check-label"
                              htmlFor={shift.id}
                            >
                              {shift.value}
                            </label>
                        </div>
                      ))}
                      {/* Display validation error */}
                      {typeof errors.selectedShift === "string" &&
                        touched.selectedShift && (
                          <div className="text-danger text-sm mt-1 mb-3" >
                            {errors.selectedShift}
                          </div>
                        )}
                    </div>
                  )}
                </FieldArray>

                <div className="d-flex gap-2 align-items-center justify-content-center">
                  {/* Close button */}
                  <Button
                    variant="outline-danger"
                    type="button"
                    onClick={props.onModalClosed}
                    disabled={props.isLoading}
                  >
                    <i className="bi bi-x-lg me-1"></i>
                    <FormattedMessage id="close" />
                  </Button>

                  {/* Submit button */}
                  <LoaderButton
                    type="submit"
                    iconName="bi-check-lg"
                    isLoading={props.isLoading}
                    text={props.id > 0 ? "button_update" : "add"}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      ) : (
        <React.Fragment>
          {/* Show message if shift is already assigned */}
          <div className="alert alert-warning text-center" role="alert">
          <FormattedMessage id="shift_assigned_error" />

          </div>
          <div className="row">
            <div className="col-6">
              <label className="text-muted bold"><FormattedMessage id="shift_date"/></label>
            </div>
            <div className="col-6">
              <p className="mw-100">{localStorage?.getItem("currentDate")}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <label className="text-muted bold"><FormattedMessage id="current_shift_name"/></label>
            </div>
            <div className="col-6">
              <p className="mw-100">
                {/* Render current shift name */}
                {props.shiftScheduleList?.map((shift: any) => {
                  return <span>{shift?.ShiftName}</span>;
                })}
              </p>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ShiftSelector;
